interface Medication {
  title: string;
  description: string;
}

interface GenerateOnInfoPressProps {
  onShowInfoPopover: (info: {heading: string; body: string}) => void;
  tt: (key: string, defaultText: string) => string;
}

export function generateOnInfoPress({
  onShowInfoPopover,
  tt,
}: GenerateOnInfoPressProps) {
  return () => {
    onShowInfoPopover({
      heading: tt('title.wlm', 'Weight loss medications'),
      body: tt(
        'description.wlm',
        'The newest class of weight loss medications help control appetite, cravings and overall food intake. Knowing if they are taking a weight loss medication allows us to direct them to possible programs, plans or kits best fitted for their nutritional needs.',
      ),
    });
  };
}

export const infoClientMWL = (
  tt: (key: string, defaultText: string) => string,
): Medication[] => {
  return [
    {
      title: tt('title.wlm', 'Weight loss medications'),
      description: tt(
        'description.wlm',
        'The newest class of weight loss medications help control appetite, cravings and overall food intake. Knowing if they are taking a weight loss medication allows us to direct them to possible programs, plans or kits best fitted for their nutritional needs.',
      ),
    },
  ];
};
